// components/AuthModal.jsx - 登录/注册弹窗
import React, { useState } from 'react';
import { theme } from '../theme';
import { signInWithGoogle, signInWithEmail, signUpWithEmail } from '../firebase';

export function AuthModal({ isOpen, onClose, onSuccess, mode, setMode }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  // Google Ads 转化追踪
  const trackSignupConversion = () => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17919082148/T_IjCIyv_PAbEKT9veBC'
      });
    }
  };

  const handleGoogleAuth = async () => {
    setLoading(true);
    setError('');
    try {
      const result = await signInWithGoogle();
      if (result?.isNewUser) {
        trackSignupConversion();
      }
      onClose();
      if (onSuccess) {
        setTimeout(() => onSuccess(), 100);
      }
    } catch (err) {
      setError(err.message || 'Google sign in failed');
    }
    setLoading(false);
  };

  const handleEmailAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      if (mode === 'signup') {
        await signUpWithEmail(email, password, name);
        trackSignupConversion();
      } else {
        await signInWithEmail(email, password);
      }
      onClose();
      if (onSuccess) {
        setTimeout(() => onSuccess(), 100);
      }
    } catch (err) {
      if (err.code === 'auth/email-already-in-use') {
        setError('Email already registered.');
      } else if (err.code === 'auth/wrong-password' || err.code === 'auth/user-not-found') {
        setError('Invalid email or password.');
      } else if (err.code === 'auth/weak-password') {
        setError('Password should be at least 6 characters.');
      } else {
        setError(err.message || 'Authentication failed');
      }
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: theme.bgCard,
          borderRadius: '16px',
          padding: '40px',
          width: '100%',
          maxWidth: '420px',
          border: '1px solid ' + theme.border
        }}
        onClick={e => e.stopPropagation()}
      >
        <h2 style={{
          fontFamily: 'Georgia, serif',
          fontSize: '32px',
          color: theme.text,
          margin: '0 0 8px',
          textAlign: 'center'
        }}>
          {mode === 'signup' ? 'Create Account' : 'Welcome Back'}
        </h2>
        <p style={{
          color: theme.textDark,
          fontSize: '18px',
          textAlign: 'center',
          margin: '0 0 28px'
        }}>
          {mode === 'signup' ? 'Free — no credit card needed' : 'Sign in to continue'}
        </p>

        {/* Google 登录按钮 */}
        <button
          onClick={handleGoogleAuth}
          disabled={loading}
          style={{
            width: '100%',
            background: '#fff',
            border: 'none',
            borderRadius: '10px',
            padding: '16px',
            fontSize: '18px',
            fontWeight: 600,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            marginBottom: '20px'
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continue with Google
        </button>

        {/* 分隔线 */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', margin: '20px 0' }}>
          <div style={{ flex: 1, height: '1px', background: theme.border }} />
          <span style={{ color: theme.textDark, fontSize: '16px' }}>or</span>
          <div style={{ flex: 1, height: '1px', background: theme.border }} />
        </div>

        {/* 邮箱登录表单 */}
        <form onSubmit={handleEmailAuth}>
          {mode === 'signup' && (
            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={e => setName(e.target.value)}
              style={{
                width: '100%',
                background: theme.bg,
                border: '1px solid ' + theme.border,
                borderRadius: '10px',
                padding: '16px 18px',
                color: theme.text,
                fontSize: '18px',
                marginBottom: '12px',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          )}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            style={{
              width: '100%',
              background: theme.bg,
              border: '1px solid ' + theme.border,
              borderRadius: '10px',
              padding: '16px 18px',
              color: theme.text,
              fontSize: '18px',
              marginBottom: '12px',
              outline: 'none',
              boxSizing: 'border-box'
            }}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            style={{
              width: '100%',
              background: theme.bg,
              border: '1px solid ' + theme.border,
              borderRadius: '10px',
              padding: '16px 18px',
              color: theme.text,
              fontSize: '18px',
              marginBottom: '16px',
              outline: 'none',
              boxSizing: 'border-box'
            }}
          />

          {error && (
            <p style={{ color: theme.red, fontSize: '16px', margin: '0 0 16px', textAlign: 'center' }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              background: theme.teal,
              border: 'none',
              borderRadius: '10px',
              padding: '16px',
              color: '#0f172a',
              fontSize: '18px',
              fontWeight: 700,
              cursor: loading ? 'wait' : 'pointer'
            }}
          >
            {loading ? 'Loading...' : (mode === 'signup' ? 'Create Free Account' : 'Sign In')}
          </button>
        </form>

        {/* 切换登录/注册 */}
        <p style={{ color: theme.textDark, fontSize: '16px', textAlign: 'center', marginTop: '20px' }}>
          {mode === 'signup' ? 'Already have an account? ' : "Don't have an account? "}
          <button
            onClick={() => setMode(mode === 'signup' ? 'signin' : 'signup')}
            style={{
              background: 'none',
              border: 'none',
              color: theme.teal,
              fontSize: '16px',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            {mode === 'signup' ? 'Sign In' : 'Sign Up'}
          </button>
        </p>
      </div>
    </div>
  );
}

export default AuthModal;
